var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElementCross = function SvgElementCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M44 16.54V8.46C44 5.28 42.72 4 39.54 4h-8.08C28.28 4 27 5.28 27 8.46v8.08c0 3.18 1.28 4.46 4.46 4.46h8.08c3.18 0 4.46-1.28 4.46-4.46ZM21 17.04V7.96C21 5.14 19.72 4 16.54 4H8.46C5.28 4 4 5.14 4 7.96v9.06c0 2.84 1.28 3.96 4.46 3.96h8.08C19.72 21 21 19.86 21 17.04ZM21 39.54v-8.08c0-3.18-1.28-4.46-4.46-4.46H8.46C5.28 27 4 28.28 4 31.46v8.08C4 42.72 5.28 44 8.46 44h8.08c3.18 0 4.46-1.28 4.46-4.46Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.758 30.757 8.485 8.485M30.757 39.242l8.485-8.485"
  }))));
};
export default SvgElementCross;